import React, {useEffect, useState} from "react"
import {FormattedMessage, injectIntl} from "react-intl"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend/index"
import OnBoardingService from "../../state/onboarding/OnBoardingService"
import GuideChecklistComponent from "../components/GuideChecklistComponent"
import {isError} from "../../state/helpers/Error"
import {START_UP_GUIDE_OPTION} from "../../state/onboarding/DataFlowTypes"

const StartUpGuideContainer = () => {
    const [selectedGuidesKeys, setSelectedGuidesKeys] = useState<Array<START_UP_GUIDE_OPTION>>([])
    const [completedGuides, setCompletedGuides] = useState(new Set<START_UP_GUIDE_OPTION>())

    useEffect(()=>{
        (async () => {
            const accountID = AppContext.getAccount().id
            const res = await OnBoardingService.GetDataFlow(accountID)
            if (!isError(res)) {
                setSelectedGuidesKeys(res.getStartUpGuideSurveySelection())
                setCompletedGuides(new Set(res.getCompletedGuides()))
            }
        })()
    }, [])

    const handleOnCheck = async (opt) => {
        if (!completedGuides.delete(opt)){
            completedGuides.add(opt)
        }

        const accountID = AppContext.getAccount().id
        const res = await OnBoardingService.UpdateDataFlow(accountID, {
            "completedGuides" : Array.from(completedGuides)
        })

        if (!isError(res)) {
            setCompletedGuides(new Set(res.getCompletedGuides()))
        }
    }

    return (
        <div className={"mb-5 mt-5 text-center"}>
            <FormattedMessage
                id="onboarding.help_article_checklist_component.description"
                defaultMessage="Here are some articles to help you get started."
            />

            <GuideChecklistComponent
                guideKeys={selectedGuidesKeys}
                completedGuides={completedGuides}
                onCheckCallBack={handleOnCheck}
            />
        </div>
    )
}

export default injectIntl(StartUpGuideContainer)


// WEBPACK FOOTER //
// ./src/onboarding/sections/StartUpGuideContainer.tsx